import * as AT from '@/constants/ActionTypes';

export const updateRowStatistics = statsPerEmployee => ({ type: AT.ROW_STATISTICS_CHANGED, payload: statsPerEmployee });
